import React from 'react';

function Button({
  children,
  variant = 'primary',
  size = 'md',
  type = 'button',
  className = '',
  disabled = false,
  onClick,
  ...props
}) {
  const baseClasses = 'inline-flex items-center justify-center font-medium focus:outline-none transition-colors';

  const variantClasses = {
    primary: 'text-white bg-black border border-black hover:bg-gray-800',
    secondary: 'text-gray-800 bg-white border border-gray-300 hover:bg-gray-100',
    danger: 'text-white bg-red-600 border border-red-600 hover:bg-red-700',
  };

  const sizeClasses = {
    sm: 'px-3 py-1.5 text-xs rounded',
    md: 'px-4 py-2 text-sm rounded-md',
    lg: 'px-6 py-3 text-base rounded-md',
  };

  const disabledClasses = disabled
    ? 'opacity-50 cursor-not-allowed'
    : 'cursor-pointer';

  const classes = `${baseClasses} ${variantClasses[variant]} ${sizeClasses[size]} ${disabledClasses} ${className}`;

  return (
    <button
      type={type}
      className={classes}
      disabled={disabled}
      onClick={onClick}
      {...props}
    >
      {children}
    </button>
  );
}

export default Button;